window.RW = (() => {

    const api = {};

    api.init = () => {
        console.log("RW Engine 6.0.0 gestartet");
    };

    api.getModule = (name) => {
        return document.querySelector(`[data-module="${name}"]`);
    };

    api.getInput = (name) => {
        const module = api.getModule(name);

        if (!module) {
            return null;
        }

        return module.querySelector("input, textarea, select");
    };

    api.getValue = (name) => {
        const input = api.getInput(name);

        if (!input) {
            return null;
        }

        if (input.type === "checkbox") {
            return input.checked;
        }

        return input.value;
    };

    api.show = (name) => {
        const module = api.getModule(name);

        if (module) {
            module.hidden = false;
        }
    };

    api.hide = (name) => {
        const module = api.getModule(name);

        if (module) {
            module.hidden = true;
        }
    };

    return api;

})();